<template>
  <div class="authentication">
    <el-form
      class="authentification__window"
      ref="form"
      :model="form"
      :rules="rules"
      label-position="top"
      label-width="120px"
    >
      <div class="authentication-logo logo">
        <img
          class="logo__img mgok-logo"
          :src="require('@/assets/img/Logo-MGOK.png')"
          alt="logo"
        />
      </div>
      <el-form-item class="authentication__field" label="Email" prop="email">
        <el-input v-model="form.email" />
      </el-form-item>
      <el-form-item
        class="authentication__field"
        label="Пароль"
        prop="password"
      >
        <el-input
          v-model="form.password"
          show-password
          prop="password"
        />
      </el-form-item>
      <el-form-item class="authentication__btn-submit">
        <el-button
          class="btn-login"
          :loading="isLoad"
          @click.prevent="onSubmit"
        >
          Войти
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "auth",
  data() {
    return {
      enterPoint: "",
      isLoad: false,
      form: {
        email: "",
        password: "",
      },
      rules: {
        email: [{ required: true, message: "email", trigger: "blur" }],
        password: [
          { required: true, message: "Введите пароль", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    mobileMode() {
      return this.$store.state.mobileMode;
    },
  },
  methods: {
    ...mapGetters(["userData", "auth", "getBaseUrl"]),
    ...mapMutations(["loginedUser"]),
    ...mapActions({
      signIn: "auth/signIn",
    }),

    async onSubmit() {
      this.isLoad = true;
      if (!this.form.email && !this.form.password) {
        this.notify(false, "Поля не заполнены");
      } else if (!this.form.email) {
        this.notify(false, "Поле Email не заполнено");
      } else if (!this.form.password) {
        this.notify(false, "Поле Пароль не заполнено");
      } else {
        const { status, messages } = await this.signIn(this.form);

        this.notify(status, messages)
      }
      this.isLoad = false;
    },
    welcomeMessage(value) {
      let name = value.split(" ")[1];
      let lastName = value.split(" ")[2];
      return `Добро пожаловать ${name} ${lastName}`;
    },
    notify(status, text) {
      const h = this.$createElement;
      this.$notify({
        title: "",
        message: h(
          "i",
          { style: `color: ${status ? "#67C23A" : " #f56c6c"}` },
          text
        ),
      });
    },
  },
  beforeMount() {
    this.enterPoint = this.globalFunctions.setEnterPoint(
      window.location.origin
    );
  },
};
</script>

<style lang="scss">
.authentication {
  background-color: $basic-white;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}
.authentification__window {
  max-width: 400px;
  width: 100%;
  position: relative;
}

.authentication-logo {
  margin: 0 auto 20px auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.logo__img {
  width: 100px;
}
.mgok-logo {
  width: 200px;
}
.logo__text-wrp {
  margin-left: 20px;
  padding-left: 20px;
  height: 70px;
  border-left: 2px solid $basic-black;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .logo__text {
    font-weight: bold;
    font-size: 18px;
  }
}
.authentication__field {
  label {
    color: $brand-clr-1;
  }
  input {
    background-color: transparent;
    border-color: $regular-text-clr;
    color: $primary-text-clr;
    font-size: 18px;
  }
}
.authentication__btn-submit {
  display: flex;
  justify-content: center;
  .btn-login {
    display: flex;
    justify-content: center;
    align-items: center;
    outline: none;
    transition-property: background-color;
    transition-duration: 0.3s;
    width: 70px;
    height: 40px;
    border-radius: 5px;
    border: 1px solid $brand-clr-1;
    color: $brand-clr-1;
    background-color: transparent;
    &:hover {
      background-color: rgba($color: $brand-clr-1, $alpha: 0.2);
    }
    // &:active{
    //     background-color: rgba($color: $brand-clr, $alpha: 0.4);
    // }
  }
  .el-button.is-loading:before {
    background-color: transparent;
  }
}

.authentication__warning-message {
  position: absolute;
  color: $danger-clr;
  width: 100%;
  text-align: center;
}
</style>
